export default "__VITE_ASSET__8f7bb66c__"